import { useFeatureValue } from '@shared/core/featureFlags';
import { useEventType } from '@shared/utils/eventType';
import { EventType } from '@graphql/generated';

export const useMergeAddGiftsAndOverviewFeature = () => {
  const { eventType } = useEventType();
  const skip = eventType !== EventType.wedding;
  return {
    isEnabled: useFeatureValue('registryMergeAddGiftAndOverviewPagesEnabled', { skip }).value === 'treatment'
  };
};
